export const MODULE_NAME = "contact-the-regulator";
export const COMMS_MODULE_NAME = "communications";
export const CONTACT_AO_MODULE_NAME = "contact-ao"
export const CTR_MODULE_NAME = "contact-the-regulator"
export const ENS_MODULE_NAME = "event-notifications"